const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Editor from './edit';
import Save from './save';

registerBlockType('base/heading-sumicity', {
  title: 'Heading - Sumicity',
  description: 'Bloco para adicionar heading tag',
  icon: 'heading',
  category: 'text',
  attributes,

  edit: (props) => <Editor {...props} />,
  save: (props) => <Save {...props} />,
});
